const runAsync = async loadingAction => {
  let data;
  let error;
  try {
    data = await loadingAction();
  } catch (err) {
    error = err;
  }
  return {
    data,
    error
  };
};
export default runAsync;